import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Input from '@hobs/components/Input';
import { required, email } from '@hobs/validations';
import { RaisedButton } from '@hobs/components/Buttons';
import Styles from './LoginForm.module.scss';

class LoginForm extends React.Component {
  // emailValidation = value => {
  //   const { translations } = this.props;

  //   if (required()(value)) {
  //     return required(translations.validation.emailRequired)(value);
  //   }
  //   if (email()(value)) {
  //     return email(translations.validation.email)(value);
  //   }

  //   return false;
  // };

  onSubmit = async (values, actions) => {
    const results = await this.props.onSubmit(values);

    if (results && !results.success) {
      actions.setSubmitting(false);
      actions.setErrors({
        password: true,
        username: true,
        form: results.message
      });
    }
  };

  render() {
    const { translations } = this.props;
    return (
      <div className={Styles.form}>
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={{
            password: '',
            username: '',
            form: null
          }}
          onSubmit={this.onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <Field
                name="username"
                validate={required(translations.validation.usernameRequired)}
                component={Input}
                large
              >
                {translations.username}
              </Field>
              <Field
                validate={required(translations.validation.passwordRequired)}
                name="password"
                type="password"
                component={Input}
                large
              >
                {translations.password}
              </Field>

              <ErrorMessage
                name="form"
                render={msg => (
                  <div data-api-error className={Styles['error-label']}>
                    {msg}
                  </div>
                )}
              />

              <RaisedButton large type="submit" disabled={isSubmitting}>
                {translations.login}
              </RaisedButton>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  translations: PropTypes.object
};

export default LoginForm;
